import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiCheck, BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { deleteAProduct, getProducts, updateAProduct, updateAProductStatus, uploadExcel } from "../features/product/productSlice";
import { Link } from "react-router-dom";
import { delImg } from "../features/upload/uploadSlice";
import CustomModal from "../components/CustomModal";
import { toast } from "react-toastify";
const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
    {
    title: "Image",
    dataIndex: "img",
    sorter: (a, b) => a.title.length - b.title.length,
  },
  {
    title: "Title",
    dataIndex: "title",
    sorter: (a, b) => a.title.length - b.title.length,
  },
  {
    title: "Brand",
    dataIndex: "brand",
    sorter: (a, b) => a.brand.length - b.brand.length,
  },
  {
    title: "Tag",
    dataIndex: "tags",
    sorter: (a, b) => a.tags.length - b.tags.length,
  },

  {
    title: "Quantity",
    dataIndex: "quantity",
  },
  {
    title: "Price",
    dataIndex: "price",
    sorter: (a, b) => a.price - b.price,
  },
  {
    title: "Mark Status",
    dataIndex: "status",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Productlist = () => {
  const [open, setOpen] = useState(false);
  const [productId, setproductId] = useState("");
    const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const { excelUploadStatus, excelUploadError,isLoading,isSuccess } = useSelector((state) => state.product);
  const showModal = (e) => {
    setOpen(true);
    setproductId(e);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please select a file");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    dispatch(uploadExcel(formData));
  };

  const hideModal = () => {
    setOpen(false);
  };
  const handleStatus=(dataValue)=>{
          const data = { id: dataValue.id, status: dataValue.status };
    dispatch(updateAProductStatus(data))
    setTimeout(()=>{
      dispatch(getProducts());
    },3000)
  }
  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch]);
  const productState = useSelector((state) => state?.product?.products);
  const data1 = [];
  for (let i = 0; i < productState.length; i++) {
    data1.push({
      key: i + 1,
      title: productState[i].title,
      brand: productState[i].brand,
      tags: productState[i].tags,
      color: productState[i].color,
      quantity: productState[i].quantity,
      price: `${productState[i].price}`,
      img:(
        <>
        <img src={productState[i]?.images[0]?.url || ""} style={{width:"40px",height:"30px"}} />
        </>
      ),
      status:(
        <>
          <button
  onClick={() => handleStatus({ id: productState[i]._id, status: 0 })}
            className="ms-3 fs-6 text-light bg-danger border-1 m-2"
          >
            {productState[i].status===0 && <BiCheck />}
           Draft
          </button>
          <button
            className="ms-3 fs-6 text-light bg-primary border-1 "
           onClick={() => handleStatus({ id: productState[i]._id, status: 1 })}
          >
            {productState[i].status===1 && <BiCheck />}
           Publish
          </button>
        </>
      ),
      action: (
        <>
          <Link
            to={`/admin/product/${productState[i]._id}`}
            className=" fs-3 text-success"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(productState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteProduct = (e) => {
    dispatch(deleteAProduct(e));
    dispatch(delImg(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getProducts());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Products</h3>

      <div className="bg-white p-6 rounded-xl shadow-md max-w-xl mx-auto mt-10 text-center">
      <h4 className="text-2xl font-semibold mb-4 flex items-center justify-center gap-2 text-green-700">Upload Excel File</h4>
      <form onSubmit={handleSubmit} className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-lg p-6 hover:border-green-400 transition duration-300">
        <input 
          type="file"
          accept=".xlsx, .xls"
            className="mb-4"
          onChange={(e) => setFile(e.target.files[0])}
        />
        <button type="submit" className="text-white rounded bg-primary">Upload</button>
      </form>

      {excelUploadStatus === "loading" && <p>Uploading...</p>}
      {excelUploadStatus === "success" && (
        <p style={{ color: "green" }}>Upload successful!</p>
      )}
      {excelUploadStatus === "failed" && (
        <p style={{ color: "red" }}>{excelUploadError?.message}</p>
      )}
    </div>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteProduct(productId);
        }}
        title="Are you sure you want to delete this Product?"
      />
    </div>
  );
};

export default Productlist;
